import { createFileRoute } from "@tanstack/react-router";
import AdminEmailAssociations from "@/pages/AdminEmailAssociations";

export const Route = createFileRoute("/admin/email-associations/")({
  component: AdminEmailAssociations,
});
